import { useContext } from 'react';
import { AnalyticsContext, AnalyticsContextProps } from './AnalyticsContext';

export const useAnalyticsContext = (): AnalyticsContextProps =>
  useContext(AnalyticsContext);
